import {
  MarketplaceCategory,
  ParsedProductPreview,
  PreparedCheckbox,
} from 'src/types/marketplace';

export const sortCategories = (categories: MarketplaceCategory[]) => {
  return categories
    .sort((a, b) => {
      if (a.displayName === b.displayName) {
        return 0;
      }

      return a.displayName > b.displayName ? 1 : -1;
    })
    .sort((a, b) => (a.number === b.number ? 0 : a.number - b.number));
};

export const sortByCount = (a: PreparedCheckbox, b: PreparedCheckbox) => {
  if (a.count === b.count) {
    return 0;
  }

  return a.count > b.count ? -1 : 1;
};

export const sortByDisplayName = (products: ParsedProductPreview[]) =>
  products.sort((a, b) => a.displayName.localeCompare(b.displayName));
